// eslint-disable-next-line no-unused-vars
const ON_CHANGE_DEBOUNCE_TIMER = 300;

// eslint-disable-next-line no-unused-vars
const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
